<template>
  <div v-if="is_loaded('init_fetch')">
        <!-- <h2 class="rates_grid_title">Драгоценные металлы</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('precious')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div> -->
        <h2 class="rates_grid_title">Золото</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('gold')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div>
        <h2 class="rates_grid_title">Серебро</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('silver')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div>
        <h2 class="rates_grid_title">Палладий</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('palladium')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div>
        <h2 class="rates_grid_title">Платина</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('platinum')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div>
        <h2 class="rates_grid_title">Базовые металлы</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group('basic')"
                :key="elem.symbol_id"
                :elem="elem"
            />
        </div>
        <!-- <h2 class="rates_grid_title">Редкие и др. металлы</h2>
        <div class="rates_grid row">
            <GridItem
                v-for="elem in symbols_of_group(2)"
                :key="elem.symbol_id"
                :elem="elem"
                :active_group="groups[2]"
            />
        </div> -->
  </div>
</template>

<script>
import GridItem from './grid_item.vue';
import { mapGetters, mapState } from 'vuex';
export default {
    components: {
        GridItem,
    },
    computed: {
        ...mapState(['all_metals_latest', 'symbols', 'groups']),
        ...mapGetters(['can', 'in_progress', 'in_progress_class', 'is_loaded']),
    },
    mounted() {
        this.$store.dispatch('init_fetch');
    },
    methods: {
        symbols_of_group(i) {
            const symbols = this.groups.find(el => el.id == i).symbols
                .map((s) => {
                    let symbol = this.symbols.find((el) => el.code === s);
                    if (symbol) {
                        return this.all_metals_latest.find((m) => m.symbol_id === symbol.id);
                    } else {
                        return false;
                    }
                })
                .filter((el) => !!el);
            return symbols;
        },

    },
}
</script>

<style>

</style>
